import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** A short transitions.dev entrance; children remain semantic DOM elements. */
export function TextReveal({ children, className }: { children: ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const block = ref.current;
    if (!block) return;
    void block.offsetHeight;
    block.classList.add('is-shown');
  }, []);

  return (
    <div ref={ref} className={cn('t-stagger', className)}>
      {children}
    </div>
  );
}
